module.exports = function SharedWorker_fn() {
  return new SharedWorker(__webpack_public_path__ + "echo-worker.worker.1230207d18515adf11c2.js");
}
